import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { LandLookups } from '../types/api';

export function useLandLookups() {
  return useQuery({
    queryKey: ['land-lookups'],
    staleTime: 60 * 60 * 1000, // rarely changes
    queryFn: async () => api.get<LandLookups>('/land-data/lookups'),
  });
}
